export default "__VITE_ASSET__BVQvTGXi__"